import { useUser } from 'hooks';
import { useMemo } from 'react';
import { IUser } from 'types/UserData.types';

interface IUseUser {
  user: IUser;
}

const useManagePermission = () => {
  const { user } = useUser() as unknown as IUseUser;

  const canViewChargeResource = useMemo(
    () => user?.data?.dayworkdocket?.can_view_charge_resource_dayworkdocket,
    [user?.data?.dayworkdocket?.can_view_charge_resource_dayworkdocket],
  );
  const canManageChargeResource = useMemo(
    () => user?.data?.dayworkdocket?.can_manage_charge_resource_dayworkdocket,
    [user?.data?.dayworkdocket?.can_manage_charge_resource_dayworkdocket],
  );

  const canAddSupplier = useMemo(
    () => user?.data?.supplier?.add_supplier,
    [user?.data?.supplier?.add_supplier],
  );

  const canChangeEquipmentHireType = useMemo(
    () => user?.data?.Timesheet?.Can_change_equipment_hire_type_in_Timesheet,
    [user?.data?.Timesheet?.Can_change_equipment_hire_type_in_Timesheet],
  );

  const canCreateNewResources = useMemo(
    () => user?.data?.resourcelibrary?.can_manage_resourcelibrary,
    [user?.data?.resourcelibrary?.can_manage_resourcelibrary],
  );

  const canCreateNewEmployeeCostSheet = useMemo(
    () => user?.data?.resourcecostsheet?.can_add_resourcecostsheet,
    [user?.data?.resourcecostsheet?.can_add_resourcecostsheet],
  );
  const canCreateNewEquipment = useMemo(
    () => user?.data?.equipment?.can_add_equipment,
    [user?.data?.equipment?.can_add_equipment],
  );
  return {
    canViewChargeResource,
    canManageChargeResource,
    canAddSupplier,
    canChangeEquipmentHireType,
    canCreateNewResources,
    canCreateNewEmployeeCostSheet,
    canCreateNewEquipment,
  };
};

export default useManagePermission;
